module.exports = __webpack_public_path__ + "img/avatar.bfcce37d.png";